import type { Maybe } from '@adornis/base/utilTypes';
import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { Folder } from '../db/Folder';

export const getFolderPath = registerQuery({
  type: () => [Folder],
  operationName: 'getFolderPath',
  resolve: (folderID: Maybe<string>) => {
    return async (gqlFields: BaseQLSelectionSet<Folder>) => {
      if (!folderID) return [];

      const rawFolderCollection = await getRawCollection<Folder>(Folder._collectionName);

      // Rekursiv den Pfad bis zur Root-Node aufbauen
      const folderPath: Folder[] = [];
      let currentFolderID = folderID;

      while (currentFolderID) {
        const folder = await rawFolderCollection.findOne<Folder>({ _id: currentFolderID });
        if (!folder) break;

        folderPath.unshift(folder); // Am Anfang einfügen, damit der Pfad von Root zu Ziel geht

        // Wenn keine parentFolderID existiert oder null ist, haben wir die Root-Node erreicht
        if (!folder.parentFolderID) break;

        currentFolderID = folder.parentFolderID;
      }

      return folderPath;
    };
  },
  params: [{ name: 'folderID', type: () => String }],
});
